module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Revoke Public Access Link","introduction":["You are about to revoke this Public Access Link. This means all attempts to submit data using the link will be denied, including records that have already been started."]}}')
  delete Component.options._Ctor
}
